/**
 * プラン一覧画面のグロッサリIDの型定義
 *
 * IDの先頭5桁（GL00x）は同一ファイル内では同じものを使用し、グロッサリファイル間では一意とする。
 * それ以降の5桁はファイル内でIDが被らないように採番する。
 */
export const PlanListGL = {
  /** image.canon サブスクリプションストアへようこそ */
  StoreTitle: 'GL00200001',
  /** リード文 */
  Lead: 'GL00200002',
  /** プラン一覧 */
  ListTitle: 'GL00200003',
  /** 詳細を見る */
  Detail: 'GL00200004',
  /** 購入する */
  Purchase: 'GL00200005',
  /** 全ての商品を表示する */
  DisplayAllPlans: 'GL00200006',

  /** 購入可能なプランがありません */
  NotFoundAnyPlan: 'GL00200007',
  /** 国/地域の指定がないためプランを表示できません。上部メニューより国/地域を選択してください */
  NotSelectedCountry: 'GL00200008',
  /** 情報を取得できませんでした */
  OtherError: 'GL00200009',
  /** トップに戻る */
  ReturnToTop: 'GL00200010',
  /** すべてのプラン(PLANLIST_0009) */
  AllPlans: 'GL00201001',
  /** カメラの拡張機能(PLANLIST_0013) */
  CameraPaidFeatures: 'GL00201002',
  /** アプリ/サービス(PLANLIST_0014) */
  App: 'GL00201003',
  /** すべての機種(PLANLIST_0010) */
  AllModels: 'GL00201004',
  /** クリア(PLANLIST_0012) */
  Clear: 'GL00201005'
} as const;
export type PlanListGLKeys = typeof PlanListGL[keyof typeof PlanListGL];
